module.exports = __webpack_public_path__ + "assets/plant-level-3.7d3545d6.svg";